import React from "react";
import i18n from "i18next";
import { connect } from "react-redux";
import { PRESETS } from "../../../workflow/presets";
import { mergeWorkflowProposal } from "../../../../../common/actions";
import "./PresetsSubstep.scss";

function PresetsSubstep({ sectionId, pluginBoxId, locale, onApply, onBack }) {
  const tr = locale === "tr";
  const disabled = !pluginBoxId;
  return (
    <div className="presets-substep">
      {disabled && (
        <div className="presets-substep__notice">
          <i className="material-icons">info</i>
          {i18n.t("Workflow.presets_select_plugin_first", {
            defaultValue: "Select an InteractivePlugin to apply a template.",
          })}
        </div>
      )}
      <div className="presets-substep__grid">
        {PRESETS.map((p) => (
          <button
            key={p.id}
            type="button"
            className="presets-substep__card"
            disabled={disabled}
            title={
              disabled ? "Add or select an InteractivePlugin to apply this template" : undefined
            }
            onClick={() => {
              if (disabled) return;
              const proposal = p.apply({ pluginBoxId });
              onApply(sectionId, proposal);
              onBack();
            }}
          >
            <div className="presets-substep__name">{tr ? p.name.tr : p.name.en}</div>
            <div className="presets-substep__desc">{tr ? p.description.tr : p.description.en}</div>
          </button>
        ))}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const present = (state.undoGroup && state.undoGroup.present) || {};
  const sceneId = present.navItemSelected;
  const scene = sceneId && (present.navItemsById || {})[sceneId];
  const boxSelected = present.boxSelected;
  return {
    sectionId: scene ? scene.parent : null,
    pluginBoxId: boxSelected && boxSelected !== -1 ? boxSelected : null,
    locale:
      (typeof window !== "undefined" &&
        window.IdealStudio &&
        window.IdealStudio.i18n &&
        window.IdealStudio.i18n.language) ||
      "en",
  };
};

const mapDispatchToProps = (dispatch) => ({
  onApply: (sectionId, proposal) => dispatch(mergeWorkflowProposal(sectionId, proposal)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PresetsSubstep);
